<bn-brightnav-layout>
  <lib-employee-conversation-list column1 [collapsed]="collapsed()"></lib-employee-conversation-list>
  <lib-chat
    column2
    class="flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden"
    [disableChat]="true"
  ></lib-chat>
</bn-brightnav-layout>
